import { render, staticRenderFns } from "./sponsor.vue?vue&type=template&id=49dc44e1&"
import script from "./sponsor.vue?vue&type=script&lang=js&"
export * from "./sponsor.vue?vue&type=script&lang=js&"
import style0 from "./sponsor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports